"use client";
import { useState } from "react";
import style from "@/styles/TabSectionFeature.module.scss";
import Image from "next/image";
import CommonCard from "@/Ui_Elements/CommonCard/CommonCard";

const data = {
  cardData: [
    {
      cardtitle: "Comprehensive Reports and Dashboards",
      category: "Instructor",
      carddesciption:
        "Get quick real-time data insights with learning management system features of integrated reports and dashboards with multi-factor defined metrics. Make the decision-making process transparent with assessment results, dashboards, and report proctoring.",
      src: "/images/homepage/features/icon-timer.svg",
      imagebgcolor: "#418DEE"
    },
    {
      cardtitle: "Simplified Online Assessment",
      category: "Instructor",
      carddesciption:
        "Vidyalaya’s cloud based learning management system offers a simplified approach to managing Online assessments. It helps conduct and evaluate competency assessments and certified exams online with better accuracy and without human intervention.",
      src: "/images/homepage/features/interactive_learning.svg",
        imagebgcolor: "#EC9246"
    },
    {
      cardtitle: "AI Integration",
      category: "Instructor",
      carddesciption:
        "We are excited to reveal what is coming up in our learning management system tools. Clarify your doubts with an AI chatbot. Generate auto generated mock quiz, AI generated video transcripts, and quiz questions.",
        src: "/images/homepage/features/refresh_circle.svg",
          imagebgcolor: "#F25471"
    },
    {
      cardtitle: "Seamless Integration",
      category: "Instructor",
      carddesciption:
        "Enhance the learning management system features with integration of different tools. Our email notifications, push notifications, reminder about new course addition, live chat integration, SMS and WhatsApp integration make the system flexible and feature rich. Auto-create course completion certificate after the course completion.",
      src: "/images/homepage/features/user_role.svg",
        imagebgcolor: "#DA5348"
    },
    {
      cardtitle: "Security",
      category: "Instructor",
      carddesciption:
        "Vidyalaya cloud learning management system offers a secure platform for eLearning. Our incorporated security practices like encryption, user access management, and role-based security protect the system from vulnerabilities.",
        src: "/images/homepage/features/progress_tracking.svg",
        imagebgcolor: "#1ABC6B"
    },
    {
      cardtitle: "Create Learning Paths",
      category: "Instructor",
      carddesciption:
        "Create learning paths, track and analyse learner progress, and plan and structure learning activities with Vidyalaya’s cloud learning management system. Our system's flexibility helps students get more control over their learning",
        src: "/images/homepage/features/emoji_happy.svg",
          imagebgcolor: "#8155E3"
    },
    {
      cardtitle: "Mobile App",
      category: "Instructor",
      carddesciption:
        "Get your learning on your fingertips with Vidyalaya’s LMS mobile app. Allow your students to access the application from anywhere, anytime and even send assignments online. Let your teachers manage content from their smartphones and students access it from their comfort zone.",
         src: "/images/homepage/features/icon-timer.svg",
      imagebgcolor: "#418DEE"
    },
    {
      cardtitle: "Rich Communication Tools",
      category: "Students",
      carddesciption:
        "Bring all learners under one roof, track their progress, and enable them to use learning management system tools like calendar, group discussions, one-to-one communication. Through these rich communication tools, keep all users informed and boost their collaboration for better outcomes.",
       src: "/images/homepage/features/interactive_learning.svg",
        imagebgcolor: "#EC9246"
    },
    {
      cardtitle: "Gamification",
      category: "Students",
      carddesciption:
        "Offer a gamified learning experience to your students and increase their excitement factor. Motivate your students with certificates, badges, points, rewards, and leader boards after certain level completion.",
       src: "/images/homepage/features/refresh_circle.svg",
          imagebgcolor: "#F25471"
    },
    {
      cardtitle: "Language Translation",
      category: "Students",
      carddesciption:
        "Facilitate multilingual generation with easy language translation learning management system tools. Let users access the course material in whatever language they want and expand your system canvas.",
        src: "/images/homepage/features/user_role.svg",
        imagebgcolor: "#DA5348"
    },
    {
      cardtitle: "Blended Learning",
      category: "Students",
      carddesciption:
        "Given the option of blended learning to students and encourage personalized eLearning experience by blending best of offline and online learning. Make the learning process more accessible and convenient by adopting Vidyalaya’s learning management system tools.",
          src: "/images/homepage/features/progress_tracking.svg",
        imagebgcolor: "#1ABC6B"
    },
    {
      cardtitle: "Single Sign-on (SSO)",
      category: "Students",
      carddesciption:
        "Ditch the trouble of remembering different credentials for different apps every day with Single Sign-on Vidyalaya’s learning management system features. Our central authentication will ensure efficiency and security.",
        src: "/images/homepage/features/emoji_happy.svg",
          imagebgcolor: "#8155E3"
    },
  ],
  tabs: [
    { name: "Students", image: "/images/liveimages/student_button_image.png" },
    { name: "Instructor", image: "/images/liveimages/instructor_button_image.png" },
  ],
};

const TabSectionFeature = (props) => {
  const { tabs, cardData } = data;

  const [activeTab, setActiveTab] = useState("All");

  // Filter cards based on the active tab
  const filterCards = () => {
    if (activeTab === "All") {
      return cardData;
    }
    return cardData.filter((card) => card.category === activeTab);
  };

  return (
    <section className={`${style["tabsectionfeature"]}`}>
      <div className={`container`}>
        <div className={`${style["cardtabscontainer"]}`}>
          {/* Dynamic Tabs */}
          <div className={`${style["tabscontainer"]}`}>
            {["All", ...tabs.map((tab) => tab.name)].map((tabName, index) => (
              <button key={index} onClick={() => setActiveTab(tabName)} className={`${style["tabbutton"]} ${activeTab === tabName ? style["activetab"] : ""}`}>
                {tabName}
                {tabs.find((tab) => tab.name === tabName)?.image && (
                  <span className={`${style["buttonimagebox"]}`}>
                    <Image
                      src={tabs.find((tab) => tab.name === tabName).image}
                      alt={tabName}
                      width={24} // Adjust size as needed
                      height={24} // Adjust size as needed
                    />
                  </span>
                )}
              </button>
            ))}
          </div>

          {/* Card List */}
          <div className={`${style["cardlistcontainer"]}`}>
            {filterCards().map((item, index) => (
              <div key={index} className={`${style["carditem"]}`}>
                <CommonCard title={item.cardtitle} description={item.carddesciption} src={item.src} backgroundcolor={item.imagebgcolor} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TabSectionFeature;
